var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04435 12.2873C1.84502 11.6457 2.34256 11 3.03624 11H20.9638C21.6574 11 22.155 11.6457 21.9556 12.2873L19.6917 19.5747C19.4289 20.4207 18.6226 21 17.7079 21H6.29206C5.37744 21 4.57111 20.4207 4.30829 19.5747L2.04435 12.2873Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67998 9.52314C2.79605 9.5079 2.91495 9.5 3.03625 9.5H20.9638C21.0851 9.5 21.204 9.5079 21.32 9.52314V7.625C21.32 6.52043 20.3928 5.625 19.2489 5.625H13.7728C13.2337 5.625 12.7157 5.42194 12.3291 5.05899L10.7389 3.56601C10.3523 3.20306 9.83435 3 9.29516 3H4.7511C3.60725 3 2.67998 3.89543 2.67998 5V9.52314Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAlt);
export default __webpack_public_path__ + "static/media/folder-alt.175bcdec45dbe794d7e25e1907c5d54c.svg";
export { ForwardRef as ReactComponent };